import {
  IUserDateVar,
  UserDateVarServer,
  VarType,
  normalizeDateVarValue,
  serializeDateVarValue
} from 'shared/entities/vars';
import { UserItemModel } from 'shared/models/users';
import { IRootStore } from 'shared/entities/store/rootStore';

import UserVarModel from './UserVarModel';

export default class UserDateVarModel
  extends UserVarModel<Date | null>
  implements IUserDateVar
{
  readonly type: VarType.date | VarType.datetime;

  constructor(params: {
    value: Date | null;
    key: string;
    chatId: string;
    user: UserItemModel;
    rootStore: IRootStore;
    type: VarType.date | VarType.datetime;
  }) {
    super(params);
    this.type = params.type;
  }

  toJson(): UserDateVarServer {
    const value = serializeDateVarValue(
      this.value.value,
      this.type,
      this.rootStore.projectStore.entity?.timezone
    );

    return {
      value: value ?? '',
      key: this.key
    };
  }
  static fromJson(
    raw: UserDateVarServer & {
      chatId: string;
      user: UserItemModel;
      rootStore: IRootStore;
      type: VarType.date | VarType.datetime;
    }
  ): UserDateVarModel {
    return new UserDateVarModel({
      value: normalizeDateVarValue(
        raw.value,
        raw.type,
        raw.rootStore.projectStore.entity?.timezone
      ),
      key: raw.key,
      chatId: raw.chatId,
      user: raw.user,
      rootStore: raw.rootStore,
      type: raw.type
    });
  }
}
